// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-title[data-v-654b1cc3]{margin-top:50px;margin-bottom:40px}.image-styles[data-v-654b1cc3]{height:400px;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
